import React, { useCallback } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventLabel from '../../components/EventLabel/EventLabel';
import PersonOutline from '@material-ui/icons/PersonOutline';
import Ballot from '@material-ui/icons/Ballot';
import _ from 'lodash';
import { PaymentType } from './types';

interface PaymentOptionButtonProps {
  option: PaymentType;
  onSelectOption: (options: PaymentType) => void;
  selectedOption: PaymentType | null;
}

const labels = {
  person: 'PersonType',
  comgov: 'ComgovType',
};

const icons = {
  person: <i className="ri-user-line ri-md" />,
  comgov: <i className="ri-briefcase-4-line ri-md" />,
};

export default function PaymentOptionButton({ option, onSelectOption, selectedOption }: PaymentOptionButtonProps) {
  const handleSelect = useCallback(() => {
    onSelectOption(option);
  }, [option, onSelectOption]);

  if (!labels[option]) return null;

  return (
    <button
      disabled={selectedOption === option}
      onClick={handleSelect}
      className={'w-full px-3 py-2 bg-transparent flex items-center gap-x-2' + (selectedOption === option ? ' active' : '')}
    >
      {selectedOption === option ? (
        <i className="ri-checkbox-circle-fill ri-md  text-[teal] top-1 right-4" />
      ) : (
        <i className="ri-checkbox-blank-circle-line ri-md text-neutral-400 top-1 right-4" />
      )}
      {icons[option]}
      <div className="text-center flex justify-center">
        <EventLabel name={labels[option]} groupName={'CMS.Payment'} />
      </div>
    </button>
  );
}
